import { get } from 'pc-sales/utils/http';

export class ServerApi {
    // 获取服务器列表
    get = (data: {
        page?: number,
        pagesize?: number,
        trade_platform?: string,
        server_id?: string,
        is_live_server?: 0 | 1,
        fields?: string
    }) => get('/v2/server', data);
}

export default new ServerApi();
